/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { AppState } from 'src/app/store/app.reducer';
import * as DeviceActions from 'src/app/store/device/device.actions';
import * as moment from 'moment';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardDynamicComponent, StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { selectCurrentDeviceFeatures, selectPasswordChange } from 'src/app/store/device/device.selector';
import { DeviceFeature } from 'src/app/model/device-feature';

@Component({
	selector: 'app-password-edit-dialog',
	templateUrl: './password-edit-dialog.component.html',
	providers: [{
		provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true }
	}]
})

export class PasswordEditDialogComponent implements OnInit, OnDestroy {
	passwordForm: FormGroup;
	passwordChange$: Observable<boolean | undefined>;
	passwordChangeSub: Subscription | undefined;
	deviceFeature$: Observable<DeviceFeature[] | undefined>;
	deviceFeatureSub: Subscription | undefined;
	passwordChange: boolean;

	lengthPassword: number;

	// design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
	) {
		this.initSelectors();
	}


	initSelectors(): void {
		// Store selectors
		this.passwordChange$ = this.store.select(selectPasswordChange);
		this.deviceFeature$ = this.store.select(selectCurrentDeviceFeatures);
	}


	ngOnInit(): void {
		this.lengthPassword = 10;
		this.subscribeAll();
		this.buildForm();

		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	subscribeAll() {
		this.passwordChangeSub = this.passwordChange$.subscribe(passwordChange => {
			this.passwordChange = passwordChange;
			if (this.passwordChange) {
				this.store.dispatch(DeviceActions.passwordVerifySupport({ password: '' }));
				this.closeDialog();
			}
		});
		this.deviceFeatureSub = this.deviceFeature$.subscribe(deviceFeatures => {
			const fea = deviceFeatures.find(fe => fe.Name === 'password');
			if (fea !== undefined) {
				this.lengthPassword = fea.Size;
				this.buildForm();
			}
		});
	}

	buildForm() {
		this.passwordForm = new FormGroup({
			'PasswordOld': new FormControl('', [Validators.maxLength(this.lengthPassword), Validators.pattern('[0-9]+')]),
			'PasswordNew': new FormControl('', [Validators.maxLength(this.lengthPassword), Validators.pattern('[0-9]+')]),
		});
	}

	ngOnDestroy(): void {
		this.passwordChangeSub?.unsubscribe();
		this.deviceFeatureSub?.unsubscribe();
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.passwordForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.passwordForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	save(): void {
		this.store.dispatch(DeviceActions.passwordChange({
			passwordOld: this.f.PasswordOld.value,
			passwordNew: this.f.PasswordNew.value
		}));
	}

	getTime(date: string): string {
		if (date === undefined) {
			return '';
		}
		return moment(date).format('HH:mm');
	}

	get f(): any {
		return this.passwordForm.controls;
	}

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: PasswordEditDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: PasswordEditDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	dynamicDatepicker(): string {
		return StandardDynamicComponent.dynamicDatepicker(this.screenWidth);
	}

	dynamicInputTextDesktopTabletWidth(): string {
		return StandardPageLayout.dynamicInputTextDesktopTabletWidth(this.screenWidth, 'w-20rem', 'w-30rem');
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}

}
